module.exports = __webpack_public_path__ + "static/media/service_body_p02.8a6e8e88.webp";